// Absolute apiBaseUrl uses that host for WS; relative /api uses the page origin (dev port split).
export function getWebSocketBaseUrl(apiBaseUrl: string): string {
  if (apiBaseUrl.startsWith('http')) {
    const url = new URL(apiBaseUrl);
    const protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${url.host}`;
  }
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}`;
}
